import React, { useState } from "react";
import {
  Box,
  Grid,
  Stack,
  TextField,
  Dialog,
  Button,
  CircularProgress,
} from "@mui/material";
import {
  SecondaryTypography,
  StyledTypography,
  ErrorTypography,
} from "../Theme";
import PhoneInput from "react-phone-input-2";
import { emailRegex } from "../utils/common";
import axiosInstance from "../AxiosInstance";
import { showToast } from "../CommonComponents/Toaster";
import { useDialog } from "../contexts/DialogContext";
import CloseIcon from "../Icons/circleClose.svg";
const AddCompanyDialogComponent = ({
  companyDetails,
  setCompanyDetails,
  setCompanyDetailsErrText,
  companyDetailsErrText,
  companies,
  open,
  onClose,
  getCompanyData,
}) => {
  const { showDialog, closeDialog } = useDialog();
  const [loading, setLoading] = useState(false);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCompanyDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
    setCompanyDetailsErrText((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const handlePhoneChange = (
    value,
    countryData,
    phoneNumberName,
    countryCodeName
  ) => {
    const dialCode = countryData.dialCode; // Country's dial code

    setCompanyDetails((prev) => ({
      ...prev,
      [phoneNumberName]: value, // Dynamically set phone number
      [countryCodeName]: dialCode, // Dynamically set country code
    }));

    setCompanyDetailsErrText((prev) => ({
      ...prev,
      [phoneNumberName]: "", // Reset error for phone number field
    }));
  };

  const validateCompanyDetails = () => {
    let isValid = true;
    const contactNumberWithoutDialCode =
      companyDetails?.company_contact_number.slice(
        companyDetails?.company_country_code.length
      );

    const errors = {
      company_name: "",
      company_country: "",
      company_email_address: "",
      company_contact_number: "",
      company_contact_countrycode: "",
      company_address: "",
    };

    if (!companyDetails.company_name.trim()) {
      errors.company_name = "Company name is required";
      isValid = false;
    }

    if (!companyDetails.company_country.trim()) {
      errors.company_country = "Country is required";
      isValid = false;
    }
    if (
      companyDetails.company_country.length < 3 ||
      companyDetails.company_country.length > 20
    ) {
      errors.company_country = "Country must be between 3 and 20 characters";
      isValid = false;
    }

    if (!companyDetails.company_email_address.trim()) {
      errors.company_email_address = "Email address is required";
      isValid = false;
    } else if (!emailRegex.test(companyDetails.company_email_address)) {
      errors.company_email_address = "Enter a valid email address";
      isValid = false;
    }

    if (!companyDetails.company_contact_number.trim()) {
      errors.company_contact_number = "Contact number is required";
      isValid = false;
    }

    if (contactNumberWithoutDialCode.length < 6) {
      errors.company_contact_number =
        "Contact number must be at least 6 characters long (excluding dial code)";
      isValid = false;
    }

    if (!companyDetails.company_address.trim()) {
      errors.company_address = "Address is required";
      isValid = false;
    }
    if (
      companyDetails?.company_name !== "" &&
      companyDetailsErrText?.company_name
    ) {
      errors.company_name = "Company name is already existed";
      isValid = false;
    }
    if (
      companyDetails.company_address.length < 3 ||
      companyDetails.company_address.length > 1000
    ) {
      errors.company_address = "Address must be between 3 and 1000 characters";
      isValid = false;
    }
    setCompanyDetailsErrText(errors);

    return isValid;
  };

  const handleAddCompany = async () => {
    if (!validateCompanyDetails()) {
      return;
    }
    setLoading(true);
    const companyData = {
      name: companyDetails?.company_name,
      email: companyDetails?.company_email_address,
      phone: companyDetails?.company_contact_number.slice(
        companyDetails?.company_country_code.length
      ),
      country_code: companyDetails?.company_country_code,
      address: companyDetails?.company_address,
      country: companyDetails?.company_country,
    };
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}company`,
        companyData
      );
      // navigate("/company");
      showDialog({
        title: "Company Added",
        content: "This company has been successfully added to the list.",
      });
      await getCompanyData();
      setLoading(false);

      onClose();
      console.log(response.data);
    } catch (error) {
      console.error(error);
      if (error.response) {
        if (error.response.status === 400) {
          const { validation_error } = error.response.data?.data;

          if (validation_error) {
            const updatedErrText = { ...companyDetailsErrText };
            Object.keys(validation_error).forEach((key) => {
              if (key === "name") {
                updatedErrText.company_name = "Company name is already existed";
                showToast("Company name is already existed", "error");
              }
            });

            setCompanyDetailsErrText(updatedErrText);
          }
        }
        if (error.response.status === 500) {
          showToast("Something went wrong! Please try again.", "error");
        }
      }

      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Dialog
      maxWidth="xl"
      BackdropProps={{
        style: {
          backdropFilter: "blur(10  px)", // Adjust the blur intensity
          backgroundColor: "rgba(0, 0, 0, 0.4)", // Optional: Adds dimming effect
        },
      }}
      PaperProps={{
        sx: {
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            display: "none", // Hide scrollbar for WebKit browsers
          },
          "-ms-overflow-style": "none", // Hide scrollbar for IE and Edge
          "scrollbar-width": "none", // Hide scrollbar for Firefox
          borderRadius: " 8px",
        }, // Set width and prevent horizontal overflow
      }}
      open={open}
      onClose={(e, reason) => {
        if (reason === "backdropClick") {
          setCompanyDetails((prev) => ({ ...prev, company_category: "" }));
        }
        setCompanyDetails((prev) => ({
          ...prev,
          company_country: "",
          company_email_address: "",
          company_contact_number: "",
          company_contact_countrycode: "",
          company_address: "",
          company_name: "",
        }));
        setCompanyDetailsErrText((prev) => ({
          ...prev,
          company_name: "",
          company_country: "",
          company_email_address: "",
          company_contact_number: "",
          company_contact_countrycode: "",
          company_address: "",
        }));

        onClose();
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={"space-between"}
        gap="10px"
        px="16px"
        sx={{
          height: "66px",
          backgroundColor: "#FCFCFD",
          border: "1px solid #E5E7EB",
          borderRadius: "8px 8px 0 0 ",
        }}
      >
        <SecondaryTypography>Company Details</SecondaryTypography>
        <img
          src={CloseIcon}
          alt="Custom Icon"
          style={{
            cursor: "pointer",
          }}
          onClick={onClose}
        />
      </Stack>
      <Box component="form">
        <Grid
          container
          xs={12}
          gap="20px"
          sx={{
            backgroundColor: "white",
            padding: "30px 16px 30px 16px",
            border: "1px solid #E5E7EB",
            borderRadius: "0px 0px 8px 8px",
          }}
        >
          <Grid xs={12} md={5.77}>
            <StyledTypography>Company Name</StyledTypography>
            <TextField
              name="company_name"
              placeholder="Enter Company Name"
              onChange={handleInputChange}
              inputProps={{ maxLength: 50 }}
              value={companyDetails?.company_name}
              fullWidth
              sx={{
                "& .MuiInputBase-root": {
                  color: companyDetailsErrText.company_name
                    ? "#912018"
                    : "#111927",
                },
                backgroundColor: companyDetailsErrText.company_name
                  ? "#FEE4E2"
                  : " #F9FAFB",
              }}
            />
            {companyDetailsErrText.company_name && (
              <ErrorTypography>
                {companyDetailsErrText.company_name}
              </ErrorTypography>
            )}
          </Grid>
          <Grid xs={12} md={5.77}>
            <StyledTypography>Country</StyledTypography>
            <TextField
              name="company_country"
              placeholder="Country"
              onChange={handleInputChange}
              value={companyDetails?.company_country}
              inputProps={{ maxLength: 20 }}
              fullWidth
              sx={{
                "& .MuiInputBase-root": {
                  color: companyDetailsErrText.company_country
                    ? "#912018"
                    : "#111927",
                },
                backgroundColor: companyDetailsErrText.company_country
                  ? "#FEE4E2"
                  : " #F9FAFB",
              }}
            />
            {companyDetailsErrText.company_country && (
              <ErrorTypography>
                {companyDetailsErrText.company_country}
              </ErrorTypography>
            )}
          </Grid>
          <Grid xs={12} md={5.77}>
            <StyledTypography>Company Email Address</StyledTypography>
            <TextField
              name="company_email_address"
              placeholder="Enter Company Email Address"
              onChange={handleInputChange}
              value={companyDetails?.company_email_address}
              inputProps={{ maxLength: 125 }}
              fullWidth
              sx={{
                "& .MuiInputBase-root": {
                  color: companyDetailsErrText.company_email_address
                    ? "#912018"
                    : "#111927",
                },
                backgroundColor: companyDetailsErrText.company_email_address
                  ? "#FEE4E2"
                  : " #F9FAFB",
              }}
            />
            {companyDetailsErrText.company_email_address && (
              <ErrorTypography>
                {companyDetailsErrText.company_email_address}
              </ErrorTypography>
            )}
          </Grid>
          <Grid item xs={12} md={5.77}>
            <StyledTypography style={{ marginBottom: "10px" }}>
              Contact Number
            </StyledTypography>
            <PhoneInput
              inputProps={{
                name: "phone",
                maxLength: 20,
              }}
              country={process.env.REACT_APP_COUNTRY_CODE || "sg"}
              onChange={(value, countryData) =>
                handlePhoneChange(
                  value,
                  countryData,
                  "company_contact_number",
                  "company_country_code"
                )
              }
              buttonStyle={{ border: "none" }}
              value={companyDetails?.company_contact_number || ""}
              inputStyle={{
                backgroundColor: companyDetailsErrText?.company_contact_number
                  ? "#FEE4E2"
                  : "#F9FAFB",
                border: "none",
                height: "46px",
                width: "100%",
                color: companyDetailsErrText.company_contact_number
                  ? "#912018"
                  : "#111927",
                borderRadius: "8px",
              }}
              name="company_contact_number"
              countryCodeEditable={false}
            />
            {companyDetailsErrText?.company_contact_number && (
              <ErrorTypography>
                {companyDetailsErrText?.company_contact_number}
              </ErrorTypography>
            )}
          </Grid>
          <Grid xs={12}>
            <StyledTypography>Company Address</StyledTypography>
            <TextField
              name="company_address"
              placeholder="Enter Company Address"
              onChange={handleInputChange}
              value={companyDetails?.company_address || ""}
              inputProps={{ maxLength: 1000 }}
              fullWidth
              sx={{
                "& .MuiInputBase-root": {
                  color: companyDetailsErrText.company_address
                    ? "#912018"
                    : "#111927",
                },
                backgroundColor: companyDetailsErrText.company_address
                  ? "#FEE4E2"
                  : " #F9FAFB",
              }}
            />
            {companyDetailsErrText?.company_address && (
              <ErrorTypography>
                {companyDetailsErrText?.company_address}
              </ErrorTypography>
            )}
          </Grid>
        </Grid>
        <Stack
          direction="row"
          py={1}
          px={1}
          justifyContent="end"
          alignItems="center"
          height="60px"
        >
          <Stack direction="column" justifyContent="end" alignItems="end">
            <Button onClick={handleAddCompany} type="button" variant="Standard">
              {loading ? (
                <CircularProgress size={25} color="inherit" />
              ) : (
                "Add New Company"
              )}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default AddCompanyDialogComponent;
